import React, { Fragment, useState, useEffect, useRef } from "react";
import { Table, Row, Col, FormGroup, Input, Button } from "reactstrap";
import {
  REQUESTLIST_URL,
  USER_DELETE_AGENCY_LIST,
} from "../../../../utils/APIEndpoints";
import { authHeader } from "../../../../utils/functions/CoreFunctions";
import API from "../../../../redux/actions/API";
import {
  amountFormat,
  getDateString,
  getAlertToast,
  getConfirm,
} from "../../../../utils/functions/CustomFunctions";
import CustomViewButton from "../../../common/CustomViewButton";
import CustomTableLoader from "../../../common/CustomTableLoader";
import CustomTableEmptyRecord from "../../../common/CustomTableEmptyRecord";
import CustomTableHeader from "../../../common/CustomTableHeader";
import { useParams, Link } from "react-router-dom";
import Pagination from "react-js-pagination";
import Swal from "sweetalert2";
import { debounce } from "underscore";
import CustomDeleteButton from "../../../common/CustomDeleteButton";
import Checkbox from "react-custom-checkbox";
import * as Icon from "react-icons/fi";
import { boolean } from "yup";

//Table Columns
const tableColumns = [
  { title: "Document Name" },
  { title: "Description" },
  { title: "Hyperlink" },
  { title: "Fee" },
  { title: "Created Date" },
  { title: "Actions" },
];

const Documents = (props) => {
  //State
  let { id } = useParams();

  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [gridData, setGridData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState([]);
  const [list, setList] = useState([]);
  const [selectedlist, setSelectedlist] = useState(false);
  const [active, setActive] = useState(false);

  const [isFilterOpen, setIsFilterOpen] = useState(false);

  const filterToggle = () => {
    setIsFilterOpen(!isFilterOpen);
  };

  const [filter, setFilter] = useState({
    serviceName: "",
  });

  //Onchange filter
  const changeFilterField = ({ target: { name, value } }) => {
    setFilter({ ...filter, [name]: value });
  };

  const handleRowPerPage = ({ target: { value } }) => {
    setCurrentPage(0);
    setRowsPerPage(value);
  };

  const onPageChanged = (page) => {
    setCurrentPage(page - 1);
    getGridData({
      ...filter,
      count: rowsPerPage || undefined,
      offset: page - 1,
      agencyId: parseInt(id),
      status: "Accepted",
      isDeleted: false,
    });
  };

  //Get Grid Data
  const getGridData = async (queryParams) => {
    try {
      setLoading(true);
      const options = {
        method: "GET",
        url: REQUESTLIST_URL,
        headers: authHeader(),
        params: queryParams,
      };
      const response = await API(options);
      const { status, data: initialResponse = [], totalCount } = response.data;
      if (status === "Success") {
        setTotalRecords(totalCount);
        let dataToDis = initialResponse.map((record) => {
          let { serviceCreatedDate, serviceAmount } = record;
          let formattedData = {
            serviceCreatedDate: getDateString(serviceCreatedDate),
            serviceAmount: amountFormat(serviceAmount),
          };

          let dataToReturn = { ...record, ...formattedData };
          return dataToReturn;
        });
        setGridData(dataToDis);
      }
      console.log(initialResponse);
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        Swal.fire(getAlertToast("error", data.message));
      }
    } finally {
      setLoading(false);
    }
  };

  const handleReset = () => {
    setFilter({
      serviceName: "",
    });
  };

  //Debounce
  const delayedQuery = useRef(
    debounce(
      (filter) =>
        getGridData({
          ...filter,
          count: rowsPerPage || undefined,
          offset: currentPage,
          agencyId: parseInt(id),
          status: "Accepted",
          isDeleted: false,
        }),
      500
    )
  ).current;

  useEffect(() => {
    getGridData({
      ...filter,
      count: rowsPerPage || undefined,
      offset: currentPage,
      agencyId: parseInt(id),
      status: "Accepted",
      isDeleted: false,
    });
  }, [rowsPerPage]);

  useEffect(() => {
    delayedQuery(filter);
  }, [filter]);

  const deleteRecordAll = async () => {
    Swal.fire(
      getConfirm("warning", "Are you sure do you want to delete?")
    ).then((result) => {
      if (result.value) {
        deleteAdmin();
      }
    });
  };

  const deleteAdmin = async () => {
    // console.log(selected.length);

    let values = [];
    selected.forEach((value) => {
      values.push({
        agencyServiceId: value,
      });
    });

    //  console.log(values)
    try {
      setLoading(true);
      const option = {
        method: "DELETE",
        url: USER_DELETE_AGENCY_LIST,
        header: authHeader(),
        data: {
          agencyId: id,
          agencyList: values,
        },
      };
      const response = await API(option);
      const { status } = response.data;
      if (status == "Success") {
        setSelected([]);
        getGridData({
          ...filter,
          count: rowsPerPage || undefined,
          offset: currentPage,
          agencyId: id,
          isDeleted: false,
        });
      }

      //  console.log(selected)
      //  console.log(id)
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        Swal.fire(getAlertToast("error", data.message));
      }
    } finally {
      setLoading(false);
    }
  };

  const onChangeChecked = (e) => {
    // console.log(e);
    let list = [];
    list.length = 0;
    if (selectedlist == false || e == true) {
      setSelectedlist(true);
      gridData.filter((record) => {
        selected.push(record.agencyServiceId);
      });
      setSelected(selected);
    } else {
      setSelectedlist(false);

      gridData.map((record) => {
        selected.shift(record.agencyServiceId);
      });
      //selected.shift(gridData.agencyServiceId)
      list.splice(0, selected.length);
      setSelected(list);
    }
  };
  // console.log(selected)
  const cheackvalues = (e, agency) => {
    // console.log(e)
    // console.log(agency)
    if (e == true) {
      selected.push(agency);
      setSelected([...selected], selected);
    } else {
      selected.shift(agency);
      setSelected([...selected], selected);
    }
  };
  const { serviceName } = filter;
  // console.log(selected)
  // console.log(selected.length)
  return (
    <Fragment>
      <div className="tableTitleBg mb-4">
        <i
          className="fas fa-filter"
          style={{
            float: "right",
            margin: "0px 7px 3px 16px",
            fontSize: "19px",
            cursor: "pointer",
          }}
          onClick={filterToggle}
        ></i>

        {selected.length > 0 ? (
          <CustomDeleteButton onClick={deleteRecordAll} />
        ) : (
          ""
        )}
      </div>
      {isFilterOpen && (
        <Row form className="mb-4">
          <Col md={3}>
            <FormGroup>
              <Input
                type="text"
                name="serviceName"
                placeholder="Document Name"
                onChange={changeFilterField}
                value={serviceName}
              />
            </FormGroup>
          </Col>
          <Col md={2}>
            <div style={{ marginTop: "10px" }}>
              <Button color="danger" onClick={handleReset}>
                Reset
              </Button>
            </div>
          </Col>
        </Row>
      )}

      <Table responsive hover>
        {/* Table Header */}
        <thead style={{ backgroundColor: "#eee" }}>
          <tr>
            <th>
              {
                <Checkbox
                  icon={<Icon.FiCheck color="#174A41" size={14} />}
                  borderColor="#D7C629"
                  checked={selectedlist}
                  onChange={onChangeChecked}
                  style={{ cursor: "pointer" }}
                />
              }
            </th>
            {tableColumns.map(({ title }, key) => (
              <th key={`head_list_${key}`}>{title}</th>
            ))}
          </tr>
        </thead>
        {/* Table Header */}
        <tbody>
          {loading ? (
            // Table Loader
            <CustomTableLoader columnsCount={tableColumns.length} />
          ) : (
            // Table Loader
            <Fragment>
              {!gridData.length ? (
                //  Empty Record
                <CustomTableEmptyRecord columnsCount={tableColumns.length} />
              ) : (
                //  Empty Record
                <Fragment>
                  {gridData.map((record, key) => (
                    <tr key={`record_key_${key}`}>
                      <td>
                        {
                          <Checkbox
                            icon={<Icon.FiCheck color="#174A41" size={14} />}
                            borderColor="#D7C629"
                            checked={selectedlist}
                            onChange={(e) =>
                              cheackvalues(e, record.agencyServiceId)
                            }
                            style={{ cursor: "pointer" }}
                          />
                        }
                      </td>
                      <td>{record.serviceName}</td>
                      <td>{record.serviceDescription}</td>
                      <td>
                        <Link
                          target="_blank"
                          to={`/preview-document/${record.serviceDomainURL}`}
                        >
                          {record.serviceDomainURL}
                        </Link>
                      </td>
                      <td>{record.serviceAmount}‎</td>
                      <td>{record.serviceCreatedDate}</td>
                      <td>
                        {/* Custom View Button  */}
                        <Link
                          target="_blank"
                          to={`/preview-document/${record.serviceDomainURL}`}
                        >
                          <CustomViewButton keyvalue={key} />
                        </Link>
                        {/* Custom View Button  */}
                      </td>
                    </tr>
                  ))}
                </Fragment>
              )}
            </Fragment>
          )}
        </tbody>
        {/* Table Body */}
      </Table>

      {gridData.length ? (
        <div className="d-flex py-4 justify-content-end space_between">
          <div className="space_between">
            <div>
              <p className="per_page">Records/Page</p>
            </div>
            <div>
              <FormGroup>
                <Input
                  className="pagi_drop"
                  type="select"
                  name="rowsPerPage"
                  onChange={handleRowPerPage}
                  value={rowsPerPage}
                >
                  <option value={""}>Show All</option>
                  <option value={10}>10</option>
                  <option value={25}>25</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                </Input>
              </FormGroup>
            </div>
          </div>
          {rowsPerPage && (
            <div>
              <Pagination
                itemClass="page-item"
                linkClass="page-link"
                activePage={currentPage + 1}
                itemsCountPerPage={rowsPerPage}
                totalItemsCount={totalRecords}
                onChange={onPageChanged}
              />
            </div>
          )}
        </div>
      ) : (
        ""
      )}
    </Fragment>
  );
};

export default Documents;
